function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import TitleAdvancedConfig from "segments/desktop/core-components/title/advanced-field-config";
import ParagraphBodyAdvancedConfig from "segments/desktop/core-components/paragraph/advanced-fields-config";
import { FIELD_TYPES } from "constants/template-field-type";
import AdvancedThemeConfig from "segments/core-configs/advanced-theme-config";
export default _object_spread_props(_object_spread({}, TitleAdvancedConfig, ParagraphBodyAdvancedConfig, AdvancedThemeConfig), {
    topicBottomMargin: {
        type: FIELD_TYPES.TEXT,
        label: "Margin between topic and paragraph (defaults: text - 16px | image - 40px)"
    },
    spaceFromParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Margin between title and text (px)"
    },
    buttonTopMargin: {
        type: FIELD_TYPES.TEXT,
        label: "Margin above button (default 32px)"
    }
});
